import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import { Button, ButtonGroup, Tooltip } from '@mui/material';
import WebAssetIcon from '@mui/icons-material/WebAsset';

const HeaderFooter = () => {
  const { t } = useTranslation();

  const {
    actions: { setProp },
    showHeader,
    showFooter,
  } = useNode(({ data: { props } }) => {
    return {
      showHeader: props.showHeader,
      showFooter: props.showFooter,
    };
  });

  const fieldValue = {
    showHeader,
    showFooter,
  };

  const onClick = (event) => {
    const fieldName = event?.currentTarget?.name;

    setProp((props) => {
      props[fieldName] = !Boolean(fieldValue[fieldName]);
    }, 500);
  };

  return (
    <div style={{ display: 'block' }}>
      <ButtonGroup
        disableElevation
        sx={{ border: 'none' }}
        aria-label='Basic button group'
        size='small'
      >
        <Tooltip title={t('showHeader')}>
          <Button
            name={'showHeader'}
            onClick={onClick}
            sx={(theme) => ({
              p: 1,
              '& span': {
                m: 0,
              },
              backgroundColor: theme.palette.secondary.light,
              color: fieldValue.showHeader
                ? theme.palette.secondary.dark
                : theme.common.buttonInactive,
              border: `none`,
            })}
            startIcon={<WebAssetIcon />}
          />
        </Tooltip>
        <Tooltip title={t('showFooter')}>
          <Button
            name={'showFooter'}
            onClick={onClick}
            sx={(theme) => ({
              p: 1,
              '& span': {
                m: 0,
              },
              backgroundColor: theme.palette.secondary.light,
              color: fieldValue.showFooter
                ? theme.palette.secondary.dark
                : theme.common.buttonInactive,
              border: `none`,
            })}
            startIcon={<WebAssetIcon sx={{ transform: 'rotate(180deg)' }} />}
          />
        </Tooltip>
      </ButtonGroup>
    </div>
  );
};

export default HeaderFooter;
